<template>
  <v-app>
    <v-main>
      <v-toolbar dense color="terciario" dark>
        <v-app-bar-nav-icon dark class="ml-1 mr-6">
          <v-avatar color="white" class="elevation-8 mt-5" size="65"><v-img :src='this.logo'></v-img></v-avatar>
        </v-app-bar-nav-icon>
        <v-spacer></v-spacer>
        <v-toolbar-title class="text-right">
          <span class="txtp body-1 text-center"></span><br>
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn small outlined @click="abrir('https://munipatulul.gob.gt/')" class="white--text primario">informacion publica</v-btn>&nbsp;&nbsp;&nbsp;
        <v-btn outlined icon @click="abrir('https://munipatulul.gob.gt/app/#/')" class="white--text"><v-icon color="black">fa-database</v-icon></v-btn>&nbsp;&nbsp;&nbsp;
        <v-btn outlined icon @click="abrir('https://munipatulul.gob.gt:2096/')" class="white--text"><v-icon color="black">fa-envelope</v-icon></v-btn>
      </v-toolbar>
      <v-container fluid>
        <v-row justify="center" align="center" class="pa-0">
          <v-col cols="12" sm="12" md="12" lg="10" xl="10" class="pa-0 mt-5 elevation-10">
            <v-card>
              <v-img
                :src='this.encabezado'
                max-height="846"
                class="grey darken-4"
                contain
              ></v-img>
            </v-card>
          </v-col>
          <v-col cols="12" sm="12" md="6" lg="5" xl="5" class="pa-0 mb-15 mt-5">
            <v-container>
              <FacebookPage pageUrl="https://www.facebook.com/munipatulul"></FacebookPage>
            </v-container>

          </v-col>
          <v-col cols="12" sm="12" md="6" lg="5" xl="5" class="pa-0 mb-15 mt-5">
            <v-container>
              <v-carousel hide-delimiters>
                <v-carousel-item
                  v-for="(item,i) in items"
                  :key="i"
                  :src="gale+item.src"
                ></v-carousel-item>
              </v-carousel>
            </v-container>
          </v-col>
          <v-col cols="12" sm="12" md="12" lg="10" xl="10" class="my-5 py-5">
          </v-col>
        </v-row>
      </v-container>
    </v-main>
    <v-footer class="footer primario">
      <v-col cols="6" class="white--text text-center pa-0 body-2">
        &copy; 2024 Zebra Tecnologias, S.A.
      </v-col>
      <v-col cols="6" class="pa-0">
        <v-img contain :src='this.zlogo' max-height="50" class="animate__animated animate__jello animate__delay-2s"></v-img>
      </v-col>
    </v-footer>
  </v-app>
</template>
<script>

import FacebookPage from "./FacebookPage.vue";

export default {
  components:{
    FacebookPage,
  },
  name: 'index',
  data: () => ({
    valid: true,
    parametro: null,
    logo:process.env.RUTA+'/img/logomuni.jpeg',
    zlogo:process.env.RUTA+'/img/logo_blanco.PNG',
    encabezado:process.env.RUTA+'/img/encabezadoweb.jpg',
    gale:process.env.RUTA+'/galeria/',
    fechaActual:null,
    items: [
      {src: 'una.jpg',},
      {src: 'dos.jpg',},
      {src: 'tres.jpg',},
      {src: 'cuatro.jpg',},
      {src: 'cinco.jpg',},
      {src: 'seis.jpg',},
    ],
  }),
  mounted () {
    this.parametro = 'go';
  },
  watch:{
    parametro () {
      this.obtenerFechaActual();
    },
  },
  methods : {
    obtenerFechaActual() {
      const fecha = new Date();
      const opcionesFecha = { year: 'numeric', month: 'long', day: 'numeric' };
      this.fechaActual = fecha.toLocaleDateString('es-ES', opcionesFecha);
    },
    abrir(destino){
      window.open(destino, '_blank');
    },
  },
}
</script>
<style scoped>
.footer {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  padding: 10px;
}
</style>



// WEBPACK FOOTER //
// src/components/index.vue